<template>
    <div  >
        <!-- <img style="position:fixed;bottom:0px;backgroud-color:#F2F5F5;opacity:0.6;z-index:-1;object-fit:fill;" src="@/assets/dashboard-bg.svg"> -->
        <div style="padding:20px;" >
            <div class="filter flex flex-jfs flex-ac" >
                
                <span style="font-weight:bold;font-family:'PingFang SC';font-size:14px;" >开始时间:</span>
                <el-date-picker
                    v-model="start_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择开始时间"
                ></el-date-picker>
                <span style="font-weight:bold;font-family:'PingFang SC';font-size:14px;" >结束时间:</span>

                <el-date-picker
                    v-model="end_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择结束时间"
                    style="margin-left: 20px;"
                ></el-date-picker>
                <el-button type="primary" size="medium" @click="getList()" >搜索</el-button>
            </div>
            <div class="center" v-loading="loadFlag" >
                <div class="center-item flex flex-col flex-jc flex-ac"  v-for="(item,index) in showList" :key="index" >
                    <div class="center-item-txt center-item-price"  >￥{{dataList[item.key] || 0 }}</div>
                    <div class="center-item-txt center-item-description"  >{{item.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    data(){
        return {
            dateList:[],
            loadFlag:false,
            showList:[
                {name:'会员购买总额',key:'member_order'},
                {name:'会员分销总额',key:'retail'},
                // {name:'会员代理总额',key:'agent'},
                {name:'能量包购买总额',key:'energy_order'},
                {name:'能量包分销总额',key:'energy_retail'},
                // {name:'能量包代理总额',key:'energy_agent'},
                {name:'用户余额总额',key:'user_wallet'},   
                {name:'用户已提现总额',key:'withdrawal'},
            ],
            dataList:{
               member_order:0,
               retail:0,
               agent:0,
               user_wallet:0,
               withdrawal:0
            } ,
            listQuery: {
                page: 1,
                limit: 10,
                start_date: "",
                end_date: "",
                name_phone: "",
            },
            start_date: "",
            end_date: "",

        }
    },
    created(){
        this.getList()
    },
    methods:{
        getList() {
            this.listQuery.start_date = this.start_date
            ? this.start_date + " 00:00:00"
            : "";
            this.listQuery.end_date = this.end_date
            ? this.end_date + " 23:59:59"
            : "";
            this.listLoading = true;
            request({
                url: "/api/backend/finance/index",
                method: "get",
                params: this.listQuery
            }).then(response => {
                this.dataList['member_order'] = response.data.member_order
                this.dataList['retail'] = response.data.retail
                this.dataList['agent'] = response.data.agent
                this.dataList['user_wallet'] = response.data.user_wallet
                this.dataList['withdrawal'] = response.data.withdrawal
                this.dataList['energy_order'] = response.data.energy_order
                this.dataList['energy_retail'] = response.data.energy_retail
                this.dataList['energy_agent'] = response.data.energy_agent


                this.list = response.data.data;
                this.total = response.data.total;
                this.listLoading = false;
            });
        },
        isObj(data){
            console.log(data,Object.prototype.toString.call(data)==='[object Object]')
            return Object.prototype.toString.call(data)==='[object Object]'
        },
        deepAnaly(data,name){
            for(let key in data){
                if(this.isObj(data[key])) {
                    this.deepAnaly(data[key],`${name}_${key}`)
                    continue;
                }
                this.dataList[`${name}_${key}`]=data[key]
            }
        }
    }
}
</script>

<style lang="scss" scoped >
    .filter{
        margin:10px 0;
    }
    .filter > * {
        margin-right:10px;
    }
    .center{
        display: grid;
        grid-auto-columns: 15%;
        grid-template-columns: 15% 15% 15% 15% 15% 15%;
        row-gap: 20px;
        column-gap: 1%;
        margin-top:20px;
        &-item{
            padding:40px 10px;
            background-color: #DBEAFE;
            border-radius: 4px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, 0.04);
            transition:box-shadow .3s;
            &-txt{
                font-weight:bold;
                color:#333333;
                transform: scale(1);
                transition: transform .3s;
            }
            &-price{
                font-size:1.2vw;
            }
            &-description{
                font-size:.7vw;
                margin-top:10px;
            }
        }
        &-item:hover{
            box-shadow: 0 2px 6px rgba(0, 0, 0, .3), 0 0 6px rgba(0, 0, 0, 0.12);
        }
        &-item:hover &-item-txt {
            transform: scale(1.2);
        }
    }
</style>